import { render, staticRenderFns } from "./TicketTypes.vue?vue&type=template&id=0abfb161&scoped=true"
import script from "./TicketTypes.vue?vue&type=script&lang=js"
export * from "./TicketTypes.vue?vue&type=script&lang=js"
import style0 from "./TicketTypes.vue?vue&type=style&index=0&id=0abfb161&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abfb161",
  null
  
)

export default component.exports